module.exports = __webpack_public_path__ + "static/8-f6a3fc4f0645f68350eb0f1eac2e3065.jpg";